import instagram from "../assets/instagram.svg";
import facebook from "../assets/facebook.svg";
import youtube from "../assets/youtube.svg";

export const providerIcons: Record<string, string> = {
	youtube,
	facebook,
	instagram,
} as const;
